import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Button,
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
// import Datepicker from 'react-datepicker';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { Get, JENIS_DUSUN, Post } from '../../function/Koneksi';
import { Tanggal } from '../../function/Format';
import { generateAlamat } from "../../function/Format";

const ModalSuratDomisili = ({ data, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const frmDex = {
		uuid: '',
		id_jenis: '',
		nik_pelapor: '',
		nik: '',
		kk: '',
		nama_pemohon: '',
		tempat_lahir: '',
		tanggal_lahir: '',
		jenis_kelamin: '',
		pekerjaan: '',
		pendidikan_terakhir: '',
		kewarganegaraan: '',
		agama: '',
		alamat: '',
		alamat_kk: '',
		status_perkawinan: '',
		tujuan_pembuatan: '',
		detail: []
	}

	const initFormData = {
		frmNik: optionData.frmNik,
		frmShdk: optionData.frmShdk,
		frmNik3: optionData.frmNik3,
		tmplistPenduduk: optionData.tmplistPenduduk,
		tmplistPenduduk3: optionData.tmplistPenduduk3,
		nikStat: null,
		nik3Stat: null,
		detail: [],
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			dataPenduduk: "none",
			frmPreviewDraft: false,
			jenis_form: ""
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}
		
		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			nikStat: optionData.nikStat,
			status: optionData.status,
		} : initFormData)
	}, [isOpen])

	const handleInputChangeNIK = (e, fld) => {
		if (e && kioskMode == false) {
			let nikStat = { value: e, label: e };

			Post("penduduk", null, { nik: e }, datanik => {
				let frmNik = [];
				let tmplistPenduduk = {}
				datanik.data.results.data.forEach(dt => {
					frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
				});

				switch (fld) {
					case "nik":
						setFormData({
							...formData,
							frmNik,
							tmplistPenduduk,
							nikStat
						})
						break;

					default:
						break;
				}

			});

		}
	};

	const changeInputText = (e, fld) => {
		switch (fld) {
			case "penghasilan":
				setDt({
					...dt,
					penghasilan: e.target.value,
				})
				break;
			default:
				// no default
				break;
		}
	};

	const getPenduduk = (e, sel, jns) => {
		if (e) {
			if (kioskMode) {
				props.setLoadingPreview(true)
			}
			else{
				setAlert({
					loadingPreview: true
				})
			}

			Get("penduduk/find", e.value, data => {
				if(data.results){
					const alamat = generateAlamat(data.results);
					let alamat_kk = "";
				
					if(data.results.data_kk){
					  alamat_kk = data.results.data_kk.alamat
					}
	
					if (jns === "pelapor") {
						if (kioskMode === false) {
							Get("penduduk/kk/"+data.results.id_kk, null, dtkk => {
								let frmNik3 = [];
								let tmplistPenduduk3 = {};
								dtkk.results.forEach(val => {
									frmNik3.push({ value: val.id, label: val.id + ' (' + val.nama + ')' });
									tmplistPenduduk3 = {
										...tmplistPenduduk3,
										[val.id]: val
									}
								});
	
								setFormData({
									...formData,
									nikStat: e,
									frmNik3,
									tmplistPenduduk3,
									status: {
										...formData.status,
										dataPenduduk: "block",
									},
								})
								setDt({
									...dt,
									nik: data.results.id,
									nik_pelapor: data.results.id,
									kk: data.results.id_kk,
									nama_pemohon: data.results.nama,
									tempat_lahir: data.results.tempat_lahir,
									tanggal_lahir: new Date(
										data.results.tanggal_lahir
									),
									pekerjaan: data.results.data_pekerjaan.nama,
									pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
									agama: data.results.data_agama.nama,
									status_perkawinan: data.results.status_perkawinan,
									jenis_kelamin: data.results.jk,
									alamat: alamat,
									alamat_kk: alamat_kk,
									kewarganegaraan: 'WNI',
									detail: []
								})
								setAlert({
									loadingPreview: false
								})
							})
						} else { // Jika mode kiosk langsung set tanpa get list kk keluarga krna sudah ada
							setFormData({
								...formData,
								nikStat: e,
								status: {
									...formData.status,
									dataPenduduk: "block",
								},
							})
							setDt({
								...dt,
								nik: data.results.id,
								nik_pelapor: data.results.id,
								kk: data.results.id_kk,
								nama_pemohon: data.results.nama,
								tempat_lahir: data.results.tempat_lahir,
								tanggal_lahir: new Date(
									data.results.tanggal_lahir
								),
								pekerjaan: data.results.data_pekerjaan.nama,
								pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
								agama: data.results.data_agama.nama,
								status_perkawinan: data.results.status_perkawinan,
								jenis_kelamin: data.results.jk,
								alamat: alamat,
								alamat_kk: alamat_kk,
								kewarganegaraan: 'WNI',
								detail: []
							})
							setAlert({
								loadingPreview: false
							})
						}
	
					} else if (jns === "pengikut") {
	
						let detail = dt.detail
						detail.push({
							nik: data.results.id,
							nama: data.results.nama,
							jk: data.results.jk,
							tanggal_lahir: new Date(
								data.results.tanggal_lahir
							),
							tempat_lahir: data.results.tempat_lahir,
							pekerjaan: data.results.data_pekerjaan.nama,
							pendidikan: data.results.data_pendidikan_terakhir.nama,
							alamat: alamat,
							alamat_kk: alamat_kk,
							shdk: data.results.data_shdk.nama,
							keterangan: "",
						})
	
						setDt({
							...dt,
							detail
						})
					}
				
					if (kioskMode) {
						props.setLoadingPreview(false)
					}
					else{
						setAlert({
							loadingPreview: false
						})
					}
				}
				else{
					if (kioskMode) {
						props.setLoadingPreview(false)
					}
					else{
						setAlert({
							loadingPreview: false
						})
					}
				}				
			})

		} else {
			switch (jns) {
				case "pelapor":
					setDt({
						...dt,
						nama_pemohon: '',
						tempat_lahir: '',
						tanggal_lahir: null,
						pekerjaan: '',
						pendidikan_terakhir: '',
						agama: '',
						status_perkawinan: '',
						jenis_kelamin: '',
						alamat: '',
						alamat_kk: '',
						detail: []
					})
					setFormData({
						...formData,
						status: {
							...formData.status,
							dataPenduduk: "none"
						},
						nikStat: null,
						frmNik3: [],
						tmplistPenduduk3: null
					})
					break;
				case "pengikut":
					setFormData({
						...formData,
						nik3Stat: null
					})
					break;
				default:
					break;
			}
		}
	};

	const hapusDetail = (i) => {
		// let currDetail = dt.detail
		let newDetail = dt.detail.splice(i, 1)

		// console.log(currDetail);
		// console.log(newDetail);
		// console.log(dt.detail);

		setDt({
			...dt,
			detail: dt.detail
		})
	};

	const simpan = (e) => {
		e.preventDefault();

		if (kioskMode){
			props.setLoadingPreview(true)
		}
		else{
			setAlert({
				loadingPreview: true
			})
		}

		let bodyRaw = {
			...dt,
			tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir), 'yyyy-mm-dd'),
			tujuan_pembuatan: document.getElementById('tujuan_pembuatan').value,
		}
		if (dt.uuid === '') {
			if (kioskMode) {
				bodyRaw.id_jenis = props.id_jenis
			} else {
				bodyRaw.id_jenis = props.location.state.uuid
			}
		}

		let validasiPelapor = formData.nikStat;

		if (validasiPelapor) {

			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}
			Post(
				"surat-keterangan/domisili/" + metode,
				bodyRaw.uuid,
				bodyRaw,
				res => {

					// For testing
					if (props.resSubmit) {
						props.resSubmit(res.status)
					}

					// this.tutupForm();
					setFormData({
						...formData,
						status: {
							...formData.status,
							btnForm: false,
							form: false,
						}
					})
					setIsOpen(false)

					if (kioskMode) {
						if (res.status === resstat) {
							let dataAntrian = {
								nama: props.data.results.nama,
								nik: props.data.results.id,
								keterangan: '',
								uuid_surat:res.data.results.uuid_surat,
								kode_surat:res.data.results.kode_surat,
							};
					
							// Set Data Surat
							props.getDataSurat(res.data.results);
					
							setTimeout(function () {
								Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {

									props.setLoadingPreview(false)

									if (res2.code === 201) {
										props.getAntrian('Surat Keterangan Domisili', 'berhasil', false, dataAntrian);
									}
									else {
										props.getAntrian('Surat Keterangan Domisili', 'gagal');
									}
								});
							}.bind(this),1000)
						}
						else{
							props.setLoadingPreview(false)
							props.getAntrian('Surat Keterangan Domisili', 'gagal');
						}
					} else {
						if (res.status === resstat) {
							const alertData = {
								get_data_surat: {
									uuid_surat: res.data.results.uuid_surat,
									kode_surat: res.data.results.kode_surat
								},
								status: {
									frmPreviewDraft: true,
									jenis_form: psn
								}
								// show: true,
								// basicType: "success",
								// basicTitle: "Data Surat Keterangan Domisili",
								// pesanAlert: "Berhasil " + psn + " Data",
								// successAlert: true,
							}
							setAlert({
							  loadingPreview: false
							})
							setAlert(alertData)
						} else {
							const alertData = {
								show: true,
								basicType: "danger",
								basicTitle: "Data Surat Keterangan Domisili",
								pesanAlert: "Gagal " + psn + " Data"
							}
							setAlert({
							  loadingPreview: false
							})
							setAlert(alertData)
						}

						// Refresh list
						setStatusRefresh(true)
					}

				}
			);
		} else {
			if (kioskMode){
				props.getAntrian('Surat Keterangan Domisili', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				setAlert({
					loadingPreview: false
				})
				setAlert(alertData)
			}
		}
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={true}
			style={{
				maxwidth: 'unset'
			}}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
				<div className="modal-header">
					<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Surat Keterangan Domisili</h5>
				</div>
				<div className="modal-body">
					<p>
						Data identitas akan terisi secara otomatis saat NIK dipilih.
						Jika ada ketidak sesuaian data, silakan ubah di data master
						penduduk.
					</p>
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid}
					/>

					<FormGroup className="row">
						<Label
							className="col-sm-3 col-form-label"
							htmlFor="nik"
						>
							NIK Pemohon
						</Label>
						<Col sm="9">
							<div data-testid="selectNIK">
								<Select
									inputId="nik"
									classNamePrefix="select"
									onChange={e => {
										getPenduduk(e, "nik", "pelapor");
									}}
									defaultValue={formData.nikStat}
									value={formData.nikStat}
									name="NIK"
									options={formData.frmNik}
									placeholder="Pilih NIK Pemohon"
									onInputChange={e => handleInputChangeNIK(e, "nik")}
									isClearable
								/>
							</div>
						</Col>
					</FormGroup>
					<div style={{ display: formData.status.dataPenduduk }}>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Nama Pemohon
							</Label>
							<Col sm="9">
								<input
									className="form-control"
									id="nama"
									type="text"
									placeholder="Nama Pemohon"
									value={dt.nama_pemohon}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Tempat Lahir
							</Label>
							<Col sm="9">
								<input
									className="form-control"
									id="tempat_lahir"
									type="text"
									placeholder="Tempat Lahir"
									value={dt.tempat_lahir}
									readOnly

									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Tanggal Lahir
							</Label>
							<Col sm="9">
								<input
									className="form-control"
									id="tanggal_lahir"
									type="text"
									placeholder="Tanggal Lahir"
									value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
								Alamat
							</Label>
							<Col sm="9">
								<input
									className="form-control"
									id="alamat_kk"
									type="text"
									// placeholder="Tempat Lahir"
									value={dt.alamat_kk}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
								Wilayah
							</Label>
							<Col sm="9">
								<input
									className="form-control"
									id="alamat"
									type="text"
									// placeholder="Tempat Lahir"
									value={dt.alamat}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
								<small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
							</Col>
						</FormGroup>
					</div>
					<FormGroup className="row">
						<Label
							className="col-sm-3 col-form-label"
							htmlFor="inputEmail3"
						>
							Jumlah Tahun Domisili
						</Label>
						<Col sm="9">
							<input
								data-testid="tujuan pembuatan"
								name="tujuan_pembuatan"
								className="form-control"
								id="tujuan_pembuatan"
								type="text"
								placeholder="Contoh : 3 tahun"
								defaultValue={dt.tujuan_pembuatan}
								required
							/>
						</Col>
					</FormGroup>
					<FormGroup className="row">
						<Label className="col-sm-3 col-form-label">
							Tambah Keluarga Yang Ikut (Jika ada)
						</Label>
						<Col sm="9">
							<div data-testid="selectNIK3">
								<Select
									inputId="nik3"
									classNamePrefix="select"
									onChange={e => {
										getPenduduk(e, "nik", "pengikut");
									}}
									defaultValue={formData.nik3Stat}
									value={formData.nik3Stat}
									name="NIK3"
									options={formData.frmNik3}
									placeholder="Pilih Anggota Keluarga"
									// onInputChange={e => this.handleInputChangeNIK(e, "nik3")}
									isClearable
								/>
							</div>
						</Col>
						{dt.detail.length > 0 ? (
							<Col sm="12">
								<table className="table table-bordered table-stripes table-hovered">
									<thead>
										<tr>
											<th>No</th>
											<th>Nama</th>
											<th>JK</th>
											<th>Tempat/Tanggal Lahir</th>
											<th>Pekerjaan</th>
											<th>Pendidikan</th>
											<th>Hubungan Keluarga</th>
											<th>
												<i className="fa fa-trash"></i>
											</th>
										</tr>
									</thead>
									<tbody>
										{dt.detail.map((val, i) => {
											let jk = "L";
											if (val.jk === "Perempuan") {
												jk = "P";
											}
											return (
												<tr key={i}>
													<td>{i + 1}</td>
													<td>{val.nama}</td>
													<td>{jk}</td>
													<td>
														{val.tempat_lahir}, {Tanggal(val.tanggal_lahir)}
													</td>
													<td>{val.pekerjaan}</td>
													<td>{val.pendidikan}</td>
													<td>{val.shdk}</td>
													<td>
														<Button
															size="xs"
															onClick={() => hapusDetail(i)}
															color="danger"
															className="btn-icon"
														>
															<i className="fa fa-trash"></i>
														</Button>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</Col>
						) : ''}
					</FormGroup>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-warning"
						onClick={() => {
							// Tutup modal
							setFormData({
								...formData,
								status: {
									...formData.status,
									form: false,
									frmPreviewDraft: false,
									jenis_form: "",
								}
							})
							setIsOpen(false)
						}}
					>
						Tutup
					</button>
					<button
						data-testid="btnSubmitCreate"
						type="submit"
						className="btn btn-primary-custom"
						disabled={formData.status.btnForm}
					>
						Simpan
					</button>
				</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalSuratDomisili;